import type { Ref } from 'vue';

export interface IntersectionHandlerCallbacks {
  onImageSizeDetermined: (size: number) => void;
  onRefreshDrawing: () => void;
}

export function useIntersectionHandler(
  rawImgSize: Ref<number>,
  handleVisibilityChange: (isIntersecting: boolean, callbacks: IntersectionHandlerCallbacks) => void,
  getRawImgSize: () => Promise<void>,
  refreshDrawing: () => void,
  defaultSize: number = 153.6
) {
  return (entries: IntersectionObserverEntry[]) => {
    const { isIntersecting } = entries[0];
    
    handleVisibilityChange(isIntersecting, {
      onImageSizeDetermined: (size: number) => {
        rawImgSize.value = size;
      },
      onRefreshDrawing: () => {
        refreshDrawing();
      },
    });
    
    // Fetch size if needed
    if (isIntersecting && rawImgSize.value === defaultSize) {
      getRawImgSize();
    }
  };
}
